module.exports = __webpack_public_path__ + "img/notpassed.6aae9743.svg";